var xhr, scheduled = false, _throttleDelay = 200, $body, $modal, $secondaryModal,$window;
var timeout = false;
var delta = 200;
var subnavOrigin = 0;
var body = document.querySelector("body");

$(function(){	
	"use strict";

    $('.waypoint').waypoint(function(direction) {
        var el = $(this.element);
        if(el.data('wpclass')){
            el.addClass(el.data('wpclass'));
        }else{
            el.addClass('hit');    
        }
        
    }, {
      offset: '85%'
    });

    if($('#cookie-bar').length>0){
       $('.cb-enable').addClass('cb-btns') ;
       $('.cb-policy').addClass('cb-btns') ;
       $('.cb-btns').wrapAll('<div class="groupedContent"></div>');
    }
    $(".fancybox").fancybox();
    
	callbacks();

    $header = $('header');

	if ("ontouchstart" in window || navigator.msMaxTouchPoints) {
		$('body').addClass('touch');
	} else {
		$('body').addClass('no-touch');		 
	}

	
    var keydown_timeout;
    $body = $('body');
    $window = $(window);
   
    $(document).on('scroll', ScrollHandler);

    $(document).on('click', '.scroll-to-element',function (e) {
        scroll2element($(this).attr('href'));
        e.preventDefault();
    });


    $(document).on('click', '[data-action="submit"]', function () {
        var target = $(this).data('target');
        $(target).submit();
        return false;
    });
	
    $(".footer__back-to-top").click(function(){
        $("html,body").animate({scrollTop: 0 },"1000");
        return false;
    });  
   
});

function openAjaxModal(href,$mm){

     $m = $mm || $modal;

    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        callbacks('#'+$m.attr('id'));
    });

}

function equalizeHeight(target){
	$('.'+ target).each(function(){
		$('.'+ target).addClass('autoHeight');
		$('.'+ target).css('min-height','auto');
		if($('.'+ target).parent().hasClass('card')){
			$('.'+ target).css('height','auto');
		}
	});
	
    var min_height = 0;
    setTimeout(function(){
        $('.'+ target).each(function(){
            if($(this).innerHeight() > min_height){
                min_height = $(this).innerHeight();
            }
        });
        if(min_height>0){
            $('.'+ target).css('min-height',min_height);
			if($('.'+ target).parent().hasClass('card')){
				$('.'+ target).css('height',min_height);
			}
        }
		$('.'+ target).each(function(){			 
			$('.'+ target).removeClass('autoHeight');
		});
		
    },500);
	
}


function form_submit_response(target, type, message, r) {
    "use strict";
    var redirect = r || false;
    //alert(message);
    
    
    var $timeout = 0;
    
    if($('body').hasClass('modal-open') ){
        $('.modal').modal('hide');
        $timeout = 300; 
    }
    setTimeout(function(){
        var _container = target || '';
        if(type == 'success'){
            var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>'; 
        }else{
            var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';   
        }
        var content = '<div class="alert alert-'+type+'"><span>'+icon+' '+message+'</span></div>'
        $('#responseModal .modal-body').html(content);  
        $('body').addClass('dark-backdrop');
        $('#responseModal').modal('show');
        $('#responseModal').on('hidden.bs.modal', function () {
            $('#responseModal .modal-body').empty();
            $('body').removeClass('dark-backdrop');
        });
    },$timeout);
    
    setTimeout(function(){
        $('#responseModal').modal('hide');
    },3000);
    
    
    if (redirect) {
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    }
}




function triggerClick(target) {
	$('.'+target).trigger('click');
}
var $header;
var $header_is_fixed = false;
function callbacks(c) {
    var container = c || '';
    ajaxContent(container + ' .ajax-content');

    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
            var c = $(this).data();
            for (var i in c) {
                if (i.indexOf('fn') == 0 && c[i] != '') {
                    var fn = c[i];
                    var params = c[ 'params' + i ] || null;

                    $(this).addClass('callbacks-executed');

                    try {
                        if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                            var callbackAfter = c[ 'after' + i ];
                            var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                            window[ fn ](params, function(){
                                window[callbackAfter](callbackAfterParams);
                            });
                        } else {
                            window[ fn ](params);
                        }
                    } catch (Error) {
                        console.log(Error + ' '+fn);
                    }
                }
            }
        }
        }
    });
}
function ScrollHandler(e) {
    
    if ($(window).scrollTop() < 300) {
        $header.removeClass('fixed');
        $body.removeClass('fixed');

        $header_is_fixed = true;
    }
    if ($(window).scrollTop() >= 300) {
        $header.addClass('fixed');
        $body.addClass('fixed');
        $header_is_fixed = false;
    }
}


function scroll2position(pos,t) {
    $('html, body').animate({scrollTop: pos}, t || 500);
}


function more(target) {
    if ($('form[name="' + target + '-nav"] ').hasClass('busy')) {
        return false;
    }

    var c = $('form[name="' + target + '-nav"] input[name="page"]').val();
    var offset = $('form[name="' + target + '-nav"] input[name="offset"]').val();
    $('form[name="' + target + '-nav"] input[name="page"]').val(Number(c) + 1);
    $('form[name="' + target + '-nav"]').addClass('busy');
    $('.load-more[data-target="'+target+'"]').hide();
    $.ajax({data: $('form[name="' + target + '-nav"]').serialize(), dataType: 'html', success: function (result) {
        $('form[name="' + target + '-nav"]').removeClass('busy');

        var $result = $('<div>' + result + '</div>');

        var num_items = $result.find('.item').length;
        if ( num_items > 0) {
            $result.find('.item').hide();
            $('.' + target + '-list').append($result.html());
            $('.' + target + '-list .item').fadeIn('fast');

            callbacks('.' + target + '-list');

            $('.load-more[data-target="'+target+'"]').show();
            if(num_items<offset){
                $(document).off('scroll', ScrollHandler);
            }
        } else {
            $('.load-more[data-target="'+target+'"]').hide();
            $(document).off('scroll', ScrollHandler);
        }

        $('.' + target + '-list .way-point-animate').waypoint(function(direction) {
            $(this.element).addClass('shown');
        }, {
            offset: '95%'
        });

        if($('.' + target + '-list').data('afterFilter')){
            window[$('.' + target + '-list').data('afterFilter')]($('.' + target + '-list').data('afterFilterParams'));
        }
    }
    });
}

var ajax_contents = [];
function ajaxContent(c){
    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {
        ajax_contents.push(
            {
                'target': $(this),
                'content':$(this).data('ajaxContent')
            }
        );
    });
    loadAjaxContent();
}

function loadAjaxContent(){
    if(ajax_contents.length > 0){
        var target  = ajax_contents[0].target,
            content = ajax_contents[0].content;
            
        /*if(target.hasClass('ajax-load-initiated')) {
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
            return false;
        }
*/
        target.addClass('ajax-load-initiated');

        target.load(content,function(){
            var uniq = (Math.random() + '').replace('0.', '');
            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}



function filter() {
    var target = arguments[0];
    var after = arguments[1];
    $('form[name="' + target + '-nav"] input[name="page"]').val(0);
    var request_data = $('form[name="' + target + '-nav"]').serializeArray(),
        excludes = ['module', 'action', 'active_for', 'language_id', 'data_type', 'country_code'],
        includes = ['cid[]','sort_term','sort_way'],
        elements = {};

    var initialHeight = $('.' + target + '-list').innerHeight();
    $('.' + target + '-list').height(initialHeight).css({'position':'relative','min-height':100,'overflow':'hidden'}).html('<div class="loading la-animate"></div>');

    $.ajax({data: request_data, dataType: 'html', success: function (data) {
        $('.' + target + '-list').css({'overflow':'visible'});
        $('.' + target + '-list').html(data).height('auto');



        var num_items = $('.' + target + '-list .item').length;
        var offset = $('form[name="' + target + '-nav"] input[name="offset"]').val();

        if (after) {
            after.call();
        }else if($('.' + target + '-list').data('afterFilter')){
            window[$('.' + target + '-list').data('afterFilter')]($('.' + target + '-list').data('afterFilterParams'));
        }

        $(document).off('scroll', ScrollHandler);
        if($('.' + target + '-list').hasClass('infinite-scroll') &&  offset != 0 && num_items == offset) {
            $(document).on('scroll', {target: target}, ScrollHandler);


            //$('.loading-more').remove();
            //$('.' + target + '-list').append('<div class="loading-more">Scroll to load more<br><i class="fa fa-arrow-down"></i></div>');
            //$('.loading-more').fadeIn('fast');
            //setTimeout(function(){
            //    $('.loading-more').fadeOut('slow',function(){
            //        $(this).remove();
            //    });
            //},5000);

        }

        if(num_items == offset){
            $('.load-more[data-target="'+target+'"]').show();
            if($('.' + target + '-list').height() < $(window).height() - $('header').height()){
                more(target);
            }
        }else{
            $('.load-more[data-target="'+target+'"]').hide();
        }



    }});

    resize();
}
 